import {initializeApp} from 'firebase/app';
import {getAuth, GoogleAuthProvider} from 'firebase/auth';
import {getFirestore, collection} from 'firebase/firestore';
import {getFunctions} from 'firebase/functions';
import {getStorage, ref} from 'firebase/storage';

import firebaseConfig from '../configs/firebase';
import environment from '../constants/environment';

export const fb = initializeApp(firebaseConfig);

export const googleProvider = new GoogleAuthProvider();

export const auth = getAuth();
export const db = getFirestore();
export const developmentProjectsDb = collection(db, `projects-${environment}`);
export const consultingProjectsDb = collection(db, `consulting-${environment}`);
export const storage = ref(getStorage());
export const functions = getFunctions(fb, 'us-central1');
